export function hexToRgba(hex: string, alpha: number = 1): string {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map((char) => char + char).join('');
    }
    if (hex.length !== 6) {
        throw new Error('유효하지 않은 hex 컬러입니다.');
    }
    // 각 색상 값 추출
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
